var lib_core = require("lib-core");

/**
 * @constructor
 */
var trayTabsStateMachine = function (root, model, name) {
    var self = this;
    this.root = root;

    this.model = model;
    this.trayTabsName = name;

    lib_core.StateMachine.call(self, null, null, this.model.scope());

    this.changeTabTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_ACTIVE_CHANGE &&
                cEvent.data('parentName') == self.trayTabsName);
        },
        function(cEvent){
            self.model.tabs.forEach(function(index, element){
                if(element.name() == cEvent.data('tabName')){
                    if(element.noSearch()){
                        self.model.searchVisible(false);
                    } else {
                        self.model.searchVisible(true);
                    }
                    self.model.activeTab(element);
                } else {
                    element.visible(false);
                }
            });
        }
    );

    this.bottomScrolledTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_TEMPLATE_SWITCHER_BUTTON_CHANGE &&
                cEvent.data('parentName') == self.trayTabsName);
        },
        function(cEvent){
            self.model.templateSwitcherButton(cEvent.data('alternative_template'));
        }
    );

    this.bottomScrolledTransition = self.addTransition("idle","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_TABS_BOTTOM_ALMOST_REACHED;
        },
        function(cEvent){
            self.model.tabs.forEach(function(index, element) {
                element.getNext();
            });
        }
    );

    this.scrollTransition = self.addTransition("idle","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_TABS_SCROLL;
        },
        function(cEvent){
            self.model.distanceToBottom(cEvent.data("distanceToBottom"));
        }
    );
 
    this.searchFilterToggleTransition = self.addTransition("idle","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_TABS_SEARCH_FILTERS_TOGGLED;
        },
        function(cEvent){
            self.model.searchFiltersEnabled(!self.model.searchFiltersEnabled());
        }
    );
 
    self.addTransition("idle","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_TABS_ADD_SEARCH_FILTER;
        },
        function(cEvent){
            var ind = cEvent.data('ind');
            self.model.addActiveSearchFilter(ind);
        }
    );

    self.addTransition("idle","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_TABS_REMOVE_SEARCH_FILTER;
        },
        function(cEvent){
            var ind = cEvent.data('ind');
            self.model.removeActiveSearchFilter(ind);
        }
    );

    self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TABS_CHANGE_FILTER &&
                cEvent.data('trayName') == self.model.name  )
        },
        function(cEvent){
            var filterIndex = cEvent.data('index');
            var key = cEvent.data('key');
            var val = cEvent.data('val');
            self.model.setFilter(filterIndex, key, val);
        }
    );

    self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TABS_SEARCHFILTER_ENTER_PRESSED &&
                cEvent.data('trayName') == self.model.name  )
        },
        function(cEvent){
            self.model.convertAll();
        }
    );

};
lib_core.inherit(trayTabsStateMachine, lib_core.StateMachine);

module.exports = trayTabsStateMachine;
